import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import queryString from 'query-string';
import { getPartnerApisHeaders } from './partnerApisHeaders';
/* Get Feedback details for a given Partner */
export const getFeedbackDetails = (mpacBaseUrl, partnerId, queryParams) => fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/reporting/feedback/details?").concat(queryString.stringify(queryParams)), {
  headers: getPartnerApisHeaders()
}).then(response => response.json());
export const getFeedbackReportsAPIPath = (partnerId, metric, queryParams) => {
  return "/rest/2/vendors/".concat(partnerId, "/reporting/feedback/metrics/").concat(metric, "?").concat(queryString.stringify(queryParams));
};

/* Gets feedback reports for a partner */
export const getFeedbacksReports = function getFeedbacksReports(mpacBaseUrl, partnerId) {
  let queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let metric = arguments.length > 3 ? arguments[3] : undefined;
  return fetchOk("".concat(mpacBaseUrl).concat(getFeedbackReportsAPIPath(partnerId, metric, queryParams)), {
    headers: getPartnerApisHeaders()
  }).then(response => response.json());
};